import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=714a75a5&scoped=true&"
import script from "./Alerts.vue?vue&type=script&lang=js&"
export * from "./Alerts.vue?vue&type=script&lang=js&"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=714a75a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714a75a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('714a75a5')) {
      api.createRecord('714a75a5', component.options)
    } else {
      api.reload('714a75a5', component.options)
    }
    module.hot.accept("./Alerts.vue?vue&type=template&id=714a75a5&scoped=true&", function () {
      api.rerender('714a75a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Alerts.vue"
export default component.exports